<template>
  <RouterView />
</template>

<script lang="ts" setup>
import { onMounted } from 'vue'
import api, { apiGet } from './services/api'

onMounted(async () => {
  const token = localStorage.getItem('auth_token')

  if (!token) return

  try {
    const res = await apiGet(api.me())

    if (!res.ok) {
      return
    }

    const data = await res.json()

    if (data?.user?.role) {
      localStorage.setItem('user_role', data.user.role)
    }
  } catch (error) {
    console.error('Auth bootstrap failed', error)
  }
})
</script>

<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
</style>
